import { useEffect, useState } from 'react';
import { discoveryApiRef, useApi } from '@backstage/core-plugin-api';
import {
  createTechDocsAddonExtension,
  TechDocsAddonLocations,
  useShadowRootElements,
} from '@backstage/plugin-techdocs-react';
import { guestTechDocsAddonsPlugin } from './guestTechDocsAddonsPlugin';
import { useIsLegacyWikiDocs } from '../wiki/useIsLegacyWikiDocs';

const DOCS_PATH = /^\/docs\/([^/]+)\/([^/]+)\/([^/]+)\/(.+)$/;

const AttachmentLinksAddon = () => {
  const discovery = useApi(discoveryApiRef);
  const isWiki = useIsLegacyWikiDocs();
  const [staticBase, setStaticBase] = useState<string>();
  const links = useShadowRootElements<HTMLAnchorElement>([
    'a[href*="attachments/"]',
  ]);

  useEffect(() => {
    discovery
      .getBaseUrl('techdocs')
      .then(base => setStaticBase(`${base}/static/docs`));
  }, [discovery]);

  useEffect(() => {
    if (!isWiki || !staticBase) return;
    links.forEach(link => {
      const url = new URL(link.href, window.location.href);
      if (url.origin !== window.location.origin) return;
      const m = decodeURIComponent(url.pathname).match(DOCS_PATH);
      if (!m || !m[4].split('/').includes('attachments')) return;
      const [, namespace, kind, name, file] = m;
      const target = `${staticBase}/${namespace}/${kind}/${name}/${file
        .split('/')
        .map(encodeURIComponent)
        .join('/')}`;
      link.setAttribute('href', target);
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    });
  }, [isWiki, links, staticBase]);

  return null;
};

export const AttachmentLinks = guestTechDocsAddonsPlugin.provide(
  createTechDocsAddonExtension({
    name: 'AttachmentLinks',
    location: TechDocsAddonLocations.Content,
    component: AttachmentLinksAddon,
  }),
);
